// extracted by mini-css-extract-plugin
export default {"menu":"MenuSection_menu__gU-v4","menuItem":"MenuSection_menuItem__z5c79"};